import { createApp } from "vue"; // 載入 Vue 3 主程式
import App from "./App.vue"; // 載入 App 主元件
import router from "./router"; // 載入 Router 設定檔

const app = createApp(App); // 建立 Vue 實例

// ========== SEO自動設定區 ==========
router.afterEach((to) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title; // 註解：自動切換標題
  }
  if (to.meta && to.meta.description) {
    let descTag = document.querySelector('meta[name="description"]'); // 註解：尋找description標籤
    if (!descTag) {
      descTag = document.createElement("meta");
      descTag.setAttribute("name", "description");
      document.head.appendChild(descTag);
    }
    descTag.setAttribute("content", to.meta.description); // 註解：自動切換描述
  }
});
// ========== SEO自動設定區 ==========

app.use(router); // 注入 Router
app.mount("#app"); // 掛載到 #app 區域
